<template>
  <payment-status
    app="McwInvoice"
    @hasError="processErrorInvoice"
    @paymentInfo="setPaymentInfo"
  >
    <div slot-scope="{ paymentInfo, isLoading }">
      <loading-screen v-if="isLoading" />
      <template v-if="isSuccess">
        <div class="mt-5">
          <div
            v-if="isCreatingRecurringPayment"
            class="mb-3"
          >
            <div class="text-center">
              <exclamation-triangle
                scale="3"
                color="red"
                class="w-full"
              />
              <h2><strong>Revisa tu correo</strong></h2>
            </div>

            <change-recurrence-notification-msisdn
              :payment-info="paymentInfo"
              :money="country.money"
            />
          </div>
          <div class="text-center">
            <img
              v-if="isMCE"
              src="@/assets/img/success.png"
              width="80px"
              alt="Transacción exitosa"
            />
            <h2><strong>¡Gracias por tu pago!</strong></h2>
          </div>
          <div class="mt-3">
            <strong>Detalle de la transacción</strong>
            <hr />
            <div
              v-for="data in paymentInfo.successInfo.invoicesInfo"
              :key="data.folio"
              class="payment format-notification"
            >
              <div class="pl-0 pr-0">
                <p>
                  <span class="float-left">Transacción:</span>
                  <span
                    class="float-right"
                  ><strong
                    id="pagoExitoso"
                    class="text-success"
                  >APROBADA</strong></span>
                </p>
                <br />
                <p>
                  <span class="float-left">Teléfono:</span>
                  <span
                    class="float-right"
                  ><strong>{{ data.formattedClientId }}</strong></span>
                </p>
                <br />
                <p>
                  <span class="float-left">Monto pagado:</span>
                  <span
                    class="float-right"
                  ><strong>{{ country.money
                  }}{{
                    data.total.toString().includes(".")
                      ? data.total
                      : `${data.total}.00`
                  }}</strong></span>
                </p>
                <br />
                <p>
                  <span
                    class="text-left"
                  >Número de autorización:
                    <strong style="float: right">{{
                      paymentInfo.successInfo.authCode
                    }}</strong></span>
                </p>
                <br />
                <p>
                  <span class="float-left">Fecha y hora:</span>
                  <span
                    class="float-right"
                  ><strong>{{
                    paymentInfo.successInfo.operationDate | localHour
                  }}</strong></span>
                </p>
                <br />
                <hr />
              </div>
            </div>
            <div class="text-center">
              <p class="font-weight-bold">
                Recibirás un sms de confirmación de pago en tu línea móvil.
              </p>
            </div>
            <div class="w-full text-center">
              <button
                class="button text-m w-75"
                :class="!(isInvoicePayment && isCreatingRecurringPayment)
                  ? 'mt-12' : ''"
                @click="onClick"
              >
                Salir
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </payment-status>
</template>
<script>
import { mapGetters } from 'vuex';
import { INVOICE_CONTROLLERS } from '@/utils/constants';
import { ExclamationTriangle } from '@/components/icons';
import PaymentStatus from '../common/RenderlessComponents/PaymentStatus';
import ChangeRecurrenceNotificationMsisdn from '../common/Components/ChangeRecurrenceNotificationMsisdn';

export default {
  name: 'PaymentSuccess',
  components: {
    PaymentStatus,
    ChangeRecurrenceNotificationMsisdn,
    ExclamationTriangle
  },
  data() {
    return {
      notificationNumber: '',
      token: '',
      error: '',
      INVOICE_CONTROLLERS,
      payment: {}
    };
  },
  computed: {
    ...mapGetters(['country', 'creditCard', 'isMCE']),
    isSuccess() {
      return this.payment && this.payment.invoiceOrderStatus === 'Successful';
    }
  },
  methods: {
    setPaymentInfo(payment) {
      this.payment = payment;
      this.mcwHook();
    },
    mcwHook() {
      const { successInfo } = this.payment;

      const {
        operationDate,
        total,
        invoicesInfo,
        resultCode = 'INTERNAL_REJECTED',
        resultStatus = 'INTERNAL_REJECTED',
        bankResponseText
      } = successInfo || {};

      const payload = this.isSuccess
        ? invoicesInfo.map(({
          folio, serviceId, total: amount, invoiceReference
        }) => ({
          orderId: folio,
          invoice: invoiceReference,
          amount,
          client: serviceId
        }))
        : [];

      const hook = this.isSuccess
        ? {
          resultCode,
          resultStatus,
          totalAmount: total,
          transactionTime: operationDate,
          bankResponseText,
          payload: payload.length > 1 ? payload : payload[0]
        }
        : {
          resultCode,
          resultStatus,
          transactionTime: new Date().toISOString()
        };

      window.parent.postMessage({ hook: JSON.stringify(hook) }, '*');
    },
    isCreatingRecurringPayment() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.isCreatingRecurringPayment;
    },
    isInvoicePayment() {
      return this.payment && !!this.payment.successInfo
      && this.payment.successInfo.invoicesInfo.length > 0;
    },
    sendBack() {
      window.parent.postMessage(
        {
          hook: 'onBack'
        },
        '*'
      );
    },
    sendSuccess() {
      window.parent.postMessage(
        {
          hook: 'onSuccess'
        },
        '*'
      );
    },
    processErrorInvoice(paymentStatus) {
      this.mcwHook();
      this.$router.push({
        name: 'BuyErrorMCW',
        query: { error: paymentStatus }
      });
    },
    acceptNotificationMsisdn() {
      this.error = '';
      if (
        this.notificationNumber.length !== 0
        && this.notificationNumber.length !== 8
      ) {
        this.error = 'El número ingresado debe ser de 8 dígitos.';
        return;
      }
      this.isLoading = true;
      const notificationNumberWithLada = this.notificationNumber ? `${this.country.lada}${this.notificationNumber}` : '';
      global.api
        .updateRecurringPaymentNotificationMsisdn(
          this.$route.params.folio,
          notificationNumberWithLada,
          INVOICE_CONTROLLERS.MCW
        )
        .then(() => {
          this.sendSuccess();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.error = 'El número ingresado no es Claro.';
          } else {
            this.error = 'Ha ocurrido un error, favor de intentar más tarde';
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClick() {
      if (this.isCreatingRecurringPayment) {
        this.acceptNotificationMsisdn();
      } else { this.sendBack(); }
    }
  }
};
</script>

<style lang="scss">
.bg {
  color: whitesmoke !important;
  background-color: grey !important;
  border-color: #dee2e6 #dee2e6 get-color('clear') !important;
}

.format-notification {
  p {
    margin-bottom: 0;
  }
}

.payment {
  margin: 10px 10px;
}

.payment-success--receipt {
  text-decoration: underline !important;
}

@media screen and (max-width: 410px) {
  .format-width {
    font-size: 12px;
  }
}

.yellow-button {
  font-size: 20px;
  background-color: rgb(255, 174, 78);
}

.cursor {
  cursor: pointer;
}
</style>
